
import { mapActions, mapState } from 'vuex';
import { validateCpf } from '@/helpers/cpf.validator';
import { checkDate } from '@/util/validate';
import UploadFile from '@/components/UploadFile.vue';
import VueRecaptcha from 'vue-recaptcha';
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import GlobalStore from '@/store/modules/global';
import { throwError } from 'rxjs';
import dayjs from 'dayjs';
import FunctionsCommuns from '@/util/FunctionsCommuns';
import SolicitacaoService from '@/services/sie-pedidos/solicitacao.service';

const actions = mapActions('siePedidos', [
  'setFormStep',
  'setDadosFormSolicitacao',
  'setEndereco',
  'setCPF',
]);
const state = mapState('siePedidos', ['form', 'dadosForm']);
export default {
  name: 'DocumentosForm',
  components: {
    UploadFile,
    VueRecaptcha,
  },
  props: {
    disabled: { type: Boolean, default: false },
  },
  data: () => ({
    siteKey: VUE_APP_RECAPTCHA_KEY,
    naoPossuiMae: false,
    naoPossuiNumero: false,
    filesErros: [],
    filesTypeErros: [],
    event: null,
    disableAdress: true,
    rules: {
      email: value => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !value || pattern.test(value) || 'E-mail inválido!';
      },
      telefone: value => {
        const pattern = /(\(?\d{2}\)?\s)?(\d{4}-\d{4})$/;
        return pattern.test(value) || 'Celular inválido!';
      },
      cpf: value => !!validateCpf(value) || 'CPF inválido!',
      cep: value => {
        const regex = /^\d{5}-\d{3}$/;
        return regex.test(value) || 'CEP inválido!';
      },
      required: value => !!value || 'Esse campo deve ser preenchido!',
      dataNascimento: value => !!checkDate(value) || 'Data de Nascimento inválida!',
    },
    disabledocumentoResponsavel: true,
    documentos: [
      'documentoFoto',
      'documentoFichaCadastral',
      'documentoCpf',
      'documentoComprovanteResidencia',
      'documentoComprovanteMatricula',
    ],
    nameDocumentos: {
      documentoRg: 'rg',
      documentoCpf: 'cpf',
      documentoComprovanteMatricula: 'comprovante_de_matricula',
      documentoComprovanteResidencia: 'comprovante_de_residencia',
      documentoFoto: 'foto',
      documentoResponsavel: 'documento_do_responsavel',
      documentoFichaCadastral: 'ficha_cadastral',
    },
    isLoading: false,
  }),
  computed: {
    ...state,
  },
  watch: {
    naoPossuiMae: function () {
      this.form.aluno.nomeMae = null;
    },
    naoPossuiNumero: function () {
      this.form.aluno.enderecoPayload.numero = null;
    },
    'form.aluno.dataNascimento': function (newValue, oldValue) {
      this.disabledocumentoResponsavel = !this.validateMenorIdade();
      if (!this.validateMenorIdade()) {
        this.filesErros = this.filesErros.filter(f => f !== 'documentoResponsavel');
        this.filesTypeErros = this.filesTypeErros.filter(f => f !== 'documentoResponsavel');
      }
    },
    'form.aluno.enderecoPayload.cep': function (newValue, oldValue) {
      const regex = /^\d{5}-\d{3}$/;
      const cep = this.form.aluno.enderecoPayload.cep;
      if (cep && regex.test(cep) && newValue !== oldValue) {
        const cepFormat = FunctionsCommuns.removeFormat(cep);
        SolicitacaoService.getDadosEndereco(cepFormat).subscribe(response => {
          if (response['result'] !== undefined) {
            const result = response['result'];
            if (!result.logradouro || !result.bairro) {
              this.disableAdress = false;
              GlobalStore.setSnackBar({
                show: true,
                message: 'CEP encontrado. Por favor digite o endereço, número e o bairro.',
                type: 'orange',
                timeout: 10000,
              });
            }
            this.setEndereco({
              numero: this.form.aluno.enderecoPayload.numero,
              ...result,
              municipio: result.localidade,
            });
          }
        });
      }
    },
  },
  mounted() {
    if (this.form.aluno.id) {
      this.naoPossuiNumero = this.form.aluno.enderecoPayload.semNumero;
      this.naoPossuiMae = !this.form.aluno.possuiMae;
      this.disabledocumentoResponsavel = !this.validateMenorIdade();
    }
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onChangeFile(value, nome) {
      const extPermitidas = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'];
      const exPermitidasFoto = ['image/jpg', 'image/jpeg'];

      if (nome === 'documentoFoto') {
        if (exPermitidasFoto.some(v => v === value.type)) {
          this.form[nome] = value;
          this.filesErros = this.filesErros.filter(f => f !== nome);
          this.filesTypeErros = this.filesTypeErros.filter(f => f !== nome);
        } else {
          this.form[nome] = null;
          this.filesTypeErros = [...this.filesTypeErros, nome];
        }
      } else if (extPermitidas.some(v => v === value.type)) {
        this.form[nome] = value;
        this.filesErros = this.filesErros.filter(f => f !== nome);
        this.filesTypeErros = this.filesTypeErros.filter(f => f !== nome);
      } else {
        this.form[nome] = null;
        this.filesTypeErros = [...this.filesTypeErros, nome];
      }
    },
    validateMenorIdade() {
      const dataAtual = dayjs(new Date(), 'DD/MM/YYYY');
      const dataNascimento =
        this.form.aluno.dataNascimento &&
        dayjs(FunctionsCommuns.formatDate(this.form.aluno.dataNascimento), 'YYYY-MM-DD');
      return dataAtual.diff(dataNascimento, 'year') < 18;
    },
    validateDocuemntos() {
      const dados = this.form;
      const validateMenorIdade = this.validateMenorIdade();
      const documentos = this.documentos;
      if (validateMenorIdade && !dados.documentoResponsavel && !this.disabledocumentoResponsavel) {
        this.filesErros = [...this.filesErros, 'documentoResponsavel'];
      }
      documentos.forEach(doc => {
        if (!dados[doc]) {
          this.filesErros = [...this.filesErros, doc];
        }
      });
      return !this.filesErros?.length || this.filesErros?.length === 0;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      const validateDocumentos = this.validateDocuemntos();
      if (isValid && validateDocumentos) {
        this.isLoading = true;
        let formData = new FormData();
        const form = this.form;
        const aluno = this.form.aluno;
        const endereco = this.form.aluno.enderecoPayload;
        const payload = {
          aluno: {
            ...aluno,
            possuiMae: !this.naoPossuiMae,
            nomeMae: aluno.nomeMae,
            menorIdade: this.validateMenorIdade(),
            cpf: FunctionsCommuns.removeFormat(aluno.cpf),
            identidade: aluno.identidade,
            dataNascimento: FunctionsCommuns.formatDate(aluno.dataNascimento),
            fone: FunctionsCommuns.removeFormat(aluno.fone),
            enderecoPayload: {
              semNumero: this.naoPossuiNumero,
              complemento: endereco.complemento || null,
              ...endereco,
              cep: FunctionsCommuns.removeFormat(endereco.cep),
            },
          },
          cpf: FunctionsCommuns.removeFormat(form.cpf),
          tipoSolicitacaoId: form.tipoSolicitacaoId,
          lgpd: form.lgpd,
          alunoId: form.alunoId || null,
        };
        formData.append(
          'payload',
          new Blob([JSON.stringify(payload)], { type: 'application/json' }),
          'payload.json'
        );

        const documentos = this.documentos;
        Object.keys(this.form).forEach(key => {
          // Verifica se o campo está mapeado em nameDocumentos e se há um arquivo válido
          if (this.nameDocumentos[key] && this.form[key] instanceof File) {
            const file = this.form[key];
            const fileExtension = file.name.split('.').pop(); // Obtém a extensão do arquivo
            const newFileName = `${this.nameDocumentos[key]}.${fileExtension}`; // Gera o novo nome do arquivo

            try {
              // Cria um novo arquivo com o nome padronizado
              const renamedFile = new File([file], newFileName, {
                type: file.type,
              });
              formData.append(key, renamedFile); // Adiciona o arquivo ao FormData
            } catch (error) {
              console.error(`Erro ao renomear o arquivo ${key}:`, error);
            }
          } else if (this.nameDocumentos[key]) {
            console.warn(`O campo ${key} não contém um arquivo válido.`);
          }
        });
        // const documentos = this.documentos;
        // formData.append("documentoRg", form.documentoRg || null);
        // formData.append("documentoCpf", form.documentoCpf);
        // formData.append(
        //   "documentoComprovanteMatricula",
        //   form.documentoComprovanteMatricula
        // );
        // formData.append(
        //   "documentoComprovanteResidencia",
        //   form.documentoComprovanteResidencia
        // );
        // formData.append("documentoFoto", form.documentoFoto);
        // formData.append(
        //   "documentoResponsavel",
        //   form.documentoResponsavel || null
        // );

        // formData.append(
        //   "documentoFichaCadastral",
        //   form.documentoFichaCadastral || null
        // );
        SolicitacaoService.gerarSolicitacao(formData).subscribe(
          response => {
            GlobalStore.setSnackBar({
              show: true,
              message: response['message'],
              type: 'success',
            });
            this.setFormStep(5);
            this.setCPF(null);
            this.isLoading = false;
          },
          error => {
            throwError(error);
            this.isLoading = false;
          }
        );
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Campos obrigatórios não preenchidos!',
          type: 'error',
        });
      }
    },
    ...actions,
  },
};
